import { ExporterPropertyBase, } from "./SDKExporterPropertyBase";
export class ExporterPropertyDefinitionBoolean extends ExporterPropertyBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = "Boolean";
        this.defaultValue = model.default;
    }
}
